import React from "react";
import styled from "styled-components";
import { func, string } from "prop-types";
import { CrossIcon } from "components/icons";

const StyledExitButton = styled.div`
  position: absolute;
  display: flex;
  top: 20px;
  right: 20px;
  height: 20px;
  width: 20px;
  z-index: 1000;
  background: ${({ background, theme }) =>
    background && theme.colors[background]};
  border-radius: 5px;
  cursor: pointer;
`;

const ExitButton = ({ background, fill, onClick }) => (
  <StyledExitButton background={background} onClick={onClick}>
    <CrossIcon fill={fill} />
  </StyledExitButton>
);

ExitButton.propTypes = {
  background: string,
  fill: string,
  onClick: func.isRequired
};

export default ExitButton;
